import { useEffect } from 'react';
import { useIntl } from 'react-intl';

const TranslatedAppTitleUpdate = (): null => {
    const intl = useIntl();
    useEffect(() => {
        // Update the document title using the browser API
        window.document.title = intl.formatMessage({ id: 'intl-msg:timed.common.subModuleName.timed' });
    });
    return null;
};

export const TranslatedAppTitleUpdateContainer = TranslatedAppTitleUpdate;
